class MobileShoppingCart extends HTMLElement {
  constructor() {
    super();
    this.controller = new AbortController();
    this.errorMessage = null;
    this.overlay = null;
    this.closeButton = null;
  }

  connectedCallback() {
    this.overlay = document.querySelector(
      '[data-mobile-shopping-cart-overlay]'
    );
    this.errorMessage = document.querySelector(
      '[data-mobile-shopping-cart-error]'
    );
    this.closeButton = document.querySelector(
      '[data-mobile-shopping-cart-close]'
    );

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeCart(), {
        signal: this.controller.signal,
      });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeCart(), {
        signal: this.controller.signal,
      });
    }

    document.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape' && this.classList.contains('translate-x-0'))
          this.closeCart();
      },
      { signal: this.controller.signal }
    );

    document.addEventListener(
      'mobile-shopping-cart:open',
      () => this.openCart(),
      { signal: this.controller.signal }
    );

    document.addEventListener(
      'cart:error',
      (e) => {
        if (e.detail.itemKey) {
          const itemError = document.querySelector(`[data-item-error="${e.detail.itemKey}"]`);
          if (itemError) {
            itemError.textContent = e.detail.message;
            itemError.classList.remove('opacity-0');
            setTimeout(() => {
              itemError.classList.add('opacity-0');
            }, 3000);
          }
        } else {
          if (this.errorMessage) {
            this.errorMessage.textContent = e.detail.message || e.detail;
            this.errorMessage.classList.remove('hidden');
            setTimeout(() => {
              this.errorMessage.classList.add('hidden');
            }, 3000);
          }
        }
      },
      { signal: this.controller.signal }
    );
  }

  openCart() {
    this.setAttribute('aria-hidden', 'false');
    this.classList.remove('translate-x-full');
    this.classList.add('translate-x-0');
    this.overlay?.classList.remove('hidden');
    window.cbScrollLock?.lock();
  }

  closeCart() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.add('translate-x-full');
    this.classList.remove('translate-x-0');
    this.overlay?.classList.add('hidden');
    window.cbScrollLock?.unlock();
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get('mobile-shopping-cart')) {
  customElements.define('mobile-shopping-cart', MobileShoppingCart);
}
